const displayOnSmallMultiSelectFilter = () => {
    return (input) => {
        let output = input;
        if (output.length > 15) {
            return output.substring(0, 15) + "...";
        }
        else {
            return output;
        }
    };
};
const ɵ0 = displayOnSmallMultiSelectFilter;
export const DisplayOnSmallMultiSelectFilter = {
    name: 'displayOnSmallMultiSelectFilter',
    filter: displayOnSmallMultiSelectFilter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-display-on-small-multi-select.filter.js.map